import React from 'react';
import { Card } from '@avila-tek/ui/src';
import { useRouter } from 'next/router';
import { OrderPayment } from '../../../models';
import { Title } from '../../shared';
import OrderItem from '../../order/OrderDetail/OrderSummary/OrderItem';
import fallbackImg from '../../../public/images/product-card-fallback.png';
import ShopcartTotal from '../../shopcart/ShopcartSummary/ShopcartTotal';

interface EmployeeDetailProps {
  orderPayment: OrderPayment;
}

function OrderPaymentSummary({ orderPayment }: EmployeeDetailProps) {
  const router = useRouter();
  const { orderProduct } = orderPayment;
  const { variant } = orderProduct;

  const showAgreedPrice =
    router.pathname.includes('ally-receivable') ||
    router.pathname.includes('payable');

  return (
    <Card className="p-4 sm:px-6 relative">
      <Title title="Resumen" />
      <OrderItem
        key={orderProduct?._id}
        title={orderProduct?.title}
        price={showAgreedPrice ? variant?.agreedPrice : orderProduct?.price}
        quantity={1}
        subtitle={variant?.sku}
        photoSrc={
          variant?.photos[0]?.src.length > 0
            ? variant?.photos[0]?.src
            : fallbackImg.src
        }
        shopCartItem={null}
        clients={null}
        comparateAtPrice={
          showAgreedPrice ? variant?.agreedPrice : orderProduct?.price
        }
      />
      <ShopcartTotal
        total={{
          subtotal: showAgreedPrice
            ? variant?.agreedPrice
            : orderProduct?.price,
          total: showAgreedPrice ? variant?.agreedPrice : orderProduct?.price,
        }}
      />
    </Card>
  );
}

export default OrderPaymentSummary;
